import axios from 'axios';
import Cookie from 'cookies-js';
import alertify from 'alertifyjs';
import config from '../../config/index';
import routes from '../../constants/routes';
import {
  WITHDRAW_FIXED_SAVING_SUCCESS,
  WITHDRAW_FIXED_SAVING_ERROR,
  WITHDRAW_FIXED_SAVING_LOADING,
  WITHDRAW_FIXED_SAVING_ERROR_DELETE
} from '../types';

const withdrawFixedSavingSuccess = withdrawal => ({
  type: WITHDRAW_FIXED_SAVING_SUCCESS,
  withdrawal
});

const withdrawFixedSavingLoading = () => ({
  type: WITHDRAW_FIXED_SAVING_LOADING
});

const withdrawFixedSavingError = error => ({
  type: WITHDRAW_FIXED_SAVING_ERROR,
  error
});

export const deleteWithdrawFixedSavingError = () => ({
  type: WITHDRAW_FIXED_SAVING_ERROR_DELETE
});

const withdrawFixedSaving = withdrawDetails => (dispatch) => {
  dispatch(withdrawFixedSavingLoading());
  const token = Cookie.get('jwtToken');
  return axios.post(
    `${config.apiUrl}${routes.WITHDRAWFIXEDSAVINGS}`, withdrawDetails, {
      headers: { Authorization: `Bearer ${token}` }
    }
  ).then((response) => {
    const { data } = response;
    console.log('response :', response);
    if (data.isSuccessful) {
      dispatch(withdrawFixedSavingSuccess(data));
      alertify
        .alert(`${data.responseMessage}`, () => {
          alertify.success('OK');
        }).setHeader('<em style="color: green; font-size: 18px; font-weight: bold;"> Success!!! </em> ');

      window.location.href = '/savings';
    } else {
      dispatch(withdrawFixedSavingError(data.responseMessage));
    }
  }).catch((error) => {
    const { data } = error.response;
    dispatch(withdrawFixedSavingLoading());
    dispatch(withdrawFixedSavingError(data.responseMessage));
    throw error;
  });
};

export default withdrawFixedSaving;